/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import Credentials from './credentials';
import {registerPlugin} from '../../spark-core';

registerPlugin('credentials', Credentials, {
  proxies: [
    'canAuthorize',
    'canRefresh'
  ]
});

export {default as Credentials} from './credentials';
export {filterScope, sortScope} from './scope';
export {default as Token} from './token';
export {default as grantErrors} from './grant-errors';
